import { useMutation } from '@tanstack/react-query';
import { deleteTask } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useDeleteTaskMutation = () =>
  useMutation({
    mutationFn: async (id: ID) => deleteTask(id),
  });
